import React from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useUser } from '../../context/useUser';
import Banner from "../../assets/images/banner.jpg";
import Logo2 from '../../assets/images/logoAmerica.png'
import useMediaQuery from '@mui/material/useMediaQuery';
import LogoPk from "../../assets/images/LogoPk.png";
import DesktopPosterPak1 from "../../assets/images/poster-1-pak-hero-dessktop.png";
import MobilePosterPak1 from "../../assets/images/poster-1-pak-hero-mobile.png";
import DesktopPosterUsa1 from "../../assets/images/new-ame-poster-01-desk.jpg";
import MobilePosterUsa1 from "../../assets/images/new-ame-poster-01-mob.jpg";
import DesktopPosterPak2 from "../../assets/images/poster-2-pak-hero-desktop.png";
import MobilePosterPak2 from "../../assets/images/poster-2-pak-hero-mobile.png";
import DesktopPosterUsa2 from "../../assets/images/poster-2-usa-hero-desktop.png";
import MobilePosterUsa2 from "../../assets/images/poster-2-usa-hero-mobile.png";
import DesktopPosterPak3 from "../../assets/images/poster-3-pak-hero-desktop.png";
import MobilePosterPak3 from "../../assets/images/poster-3-pak-hero-mobile.png";
import DesktopPosterUsa3 from "../../assets/images/poster-3-usa-hero-desktop.png";
import MobilePosterUsa3 from "../../assets/images/poster-3-usa-hero-mobile.png";
import { useNavigate } from 'react-router-dom';

function LandingCarousel() {
    const { country } = useUser();
    const isMobile = useMediaQuery('(min-width:768px)');
    const navigate = useNavigate()

    return (
        <div>
            <Carousel
                showThumbs={false}
                showStatus={false}
                showIndicators={false}
                showArrows={false}
                infiniteLoop
                autoPlay={true}
                interval={5000}
            >
                <div
                    style={{ height: isMobile ? "calc(100vh - 90px)" : "100%" }}
                    className="relative overflow-hidden"
                >
                    {
                        isMobile ?
                            <img src={country === "PK" ? DesktopPosterPak1 : DesktopPosterUsa1} className='h-full w-full' /> :
                            <img src={country === "PK" ? MobilePosterPak1 : MobilePosterUsa1} className='h-full w-full' />
                    }
                    <button
                        onClick={() => { navigate('/book-your-qurbani') }}
                        className={`mt-6 ${country === "PK" ? "bg-[#8a2e25] text-white" : `${isMobile ? 'text-[white] bg-[#65754d]' : 'bg-[white] text-[#65754d]'}`}  ${isMobile ? ' absolute  bottom-[21vh] left-1/2 transform -translate-x-1/2' : ' absolute bottom-[15px] left-[15px]'} px-4 py-1 md:px-[2vw] md:py-[1.5vh] rounded-md text-lg font-semibold`}
                    >
                        Order Now
                    </button>
                </div>
                <div
                    style={{ height: isMobile ? "calc(100vh - 90px)" : "100%" }}
                    className="relative overflow-hidden"
                >
                    <button
                        onClick={() => { navigate('/book-your-qurbani') }}
                        className={`mt-6 ${country === "PK" ? "bg-[#8a2e25]" : "bg-[#65754d]"} text-white ${isMobile?'absolute bottom-[10vh] left-1/2 transform -translate-x-1/2':'absolute bottom-[100px] right-[20px]'} px-[2vw] py-[1.5vh] rounded-md text-lg font-semibold`}
                    >
                        Order Now
                    </button>
                    {
                        isMobile ?
                            <img src={country === "PK" ? DesktopPosterPak2 : DesktopPosterUsa2} className='h-full w-full' /> :
                            <img src={country === "PK" ? MobilePosterPak2 : MobilePosterUsa2} className='h-full w-full' />
                    }
                </div>
                <div
                    style={{ height: isMobile ? "calc(100vh - 90px)" : "100%" }}
                    className="relative overflow-hidden"
                >
                    {
                        isMobile ?
                            <img src={country === "PK" ? DesktopPosterPak3 : DesktopPosterUsa3} className='h-full w-full' /> :
                            <img src={country === "PK" ? MobilePosterPak3 : MobilePosterUsa3} className='h-full w-full' />
                    }
                </div>
                <div
                    style={{
                        height: isMobile ? "calc(100vh - 90px)" : "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#171714",
                    }}
                    className="relative"
                >
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            background: `
                            linear-gradient(to right, rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0) 60%), 
                            url(${Banner})`,
                            backgroundSize: !isMobile ? "cover" : "contain",
                            backgroundPosition: "right center",
                            backgroundRepeat: "no-repeat",
                        }}
                    >
                        <div className="max-w-[1400px] flex md:items-center h-full mx-auto py-10 md:py-0 px-6 md:px-8 text-white">
                            <div className='text-left'>
                                <img src={country === "PK" ? LogoPk : Logo2} alt="Logo" className={`mb-0 ${country === "PK" ? "md:mb-0 right-[40px]" : " md:mb-8 right-[20px]"} max-w-[200px] md:max-w-[250px] relative`} />
                                <h1 className="font-[600] max-w-[700px] text-4xl text-[#ffffff] md:text-7xl">
                                    Fresh & Halal Meat, Delivered!
                                </h1>
                                <p className="mt-2 max-w-[450px] text-lg text-[#f2f2f2]">
                                    Premium-quality beef, mutton, and chicken—sourced with care,
                                    processed hygienically, and delivered fresh. Taste the
                                    difference today!
                                </p>
                                <button onClick={() => { navigate('/book-your-qurbani') }} className={`mt-6 ${country === "PK" ? "bg-[#8a2e25]" : "bg-[#65754d]"}  text-white px-6 py-3 rounded-md text-lg font-semibold`}>
                                    Order Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Carousel>
        </div>
    )
}

export default LandingCarousel
